import Vue from 'vue'
import 'normalize.css'

import App from './App.vue'
import router from './router'
// import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import './styles/index.styl'
import '@/assets/css/theme/index.css'
import '@/assets/css/iconfont/iconfont.css'

import './permission'
import './utils/filter'
// import './components/index'
// import Permission from './directive/permission/'
// Vue.use(Permission);

import api from './api'
Vue.prototype.$api = api;

// import bus from '@/utils/bus'
// Vue.prototype.$bus = bus;

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  // store,
  render: h => h(App)
});
